import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=11db5bc4&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=11db5bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db5bc4",
  null
  
)

export default component.exports